import { AB_OPTIONS_VARIANTS, AB_VARIANTS, useAB } from '@namespace/ab-test';
import { useIsCurrencyUahAndNotVipUser } from '../useIsCurrencyUahAndNotVipUser';

export const useGetDefaultDepositAmount = (defaultAmount: string | number) => {
  const variant = useAB(AB_VARIANTS.PRESET_DEPOSIT_UAH);
  const isCurrencyUahAndNotVipUser = useIsCurrencyUahAndNotVipUser();

  return isCurrencyUahAndNotVipUser && variant === AB_OPTIONS_VARIANTS.VARIANT_B
    ? '500'
    : defaultAmount;
};
